export default "__VITE_ASSET__mltjimUY__"